import axios from "axios";
import { generateBaseUri } from "./helper";

const publicAxios = axios.create({
  baseURL: generateBaseUri(),
  headers: {
    "Content-Type": "application/json",
    // Authorization: `Bearer ${getToken()}`,
    "X-App": "wa",
  },
  timeout: 100000,
});

export default publicAxios;
